import { constants, mediaQueryStyles } from "@newsela/angelou";

import challengesRowBackground from "../../challenges/ChallengeWrapperView/challengesRowBackground.png";
import challengesRowBackgroundLarge from "../../challenges/ChallengeWrapperView/challengesRowBackgroundLarge.png";
import challengesRowBackgroundSmall from "../../challenges/ChallengeWrapperView/challengesRowBackgroundSmall.png";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, lg },
} = constants.breakpoints;
export const challengesLayoutCss = (isTeacher) => ({
  display: "flex",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
  margin: "0",
  flexDirection: "column",
  background:
    !isTeacher && `url(${challengesRowBackgroundSmall.src}) no-repeat`,
  backgroundAttachment: "initial",
  backgroundPosition: "center top",

  [mq.downTo(xs)]: {
    background: !isTeacher && `url(${challengesRowBackground.src}) no-repeat`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },

  [mq.downTo(lg)]: {
    background:
      !isTeacher && `url(${challengesRowBackgroundLarge.src}) no-repeat`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
});
